import React, { useMemo } from "react";

import { Box, Typography } from "@mui/material";
import { round, sum } from "lodash";
import { makeStyles } from "tss-react/mui";

import { MealDetailsFragment } from "@/gql/graphql";

import { calculateMacro } from "../utils/macros";

interface Props {
  meal: MealDetailsFragment | undefined;
}

const MealMacros: React.FC<Props> = ({ meal }) => {
  const { classes } = useStyles();

  const totalEnergy = round(sum(meal?.mealFoods?.map((f) => f.energyKcal)));
  const totalCarbs = useMemo(
    () => round(sum(meal?.mealFoods?.map((f) => f.carbohydrateGrams)), 2),
    [meal]
  );
  const totalProteins = useMemo(
    () => round(sum(meal?.mealFoods?.map((f) => f.proteinGrams)), 2),
    [meal]
  );
  const totalFat = useMemo(
    () => round(sum(meal?.mealFoods?.map((f) => f.fatGrams)), 2),
    [meal]
  );
  const calculate = calculateMacro(totalEnergy);
  const carbsPercent = calculate.carbsPercentage(totalCarbs);
  const proteinsPercent = calculate.proteinPercentage(totalProteins);
  const fatPercent = calculate.fatsPercentage(totalFat);

  return (
    <Box className={classes.root}>
      <Typography>
        Carb: {totalCarbs} g | {carbsPercent} %
      </Typography>
      <Typography>
        Protein: {totalProteins} g | {proteinsPercent} %
      </Typography>
      <Typography>
        Fat: {totalFat} g | {fatPercent} %
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles()({
  root: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 12,
  },
});

export default MealMacros;
